<template>
    <div>
        <h1 style="font-size: 24px; color: black;">红包币日报</h1>
        <el-card class="form-container" style="margin-top: 25px" shadow="never">
            <el-form  :inline="true" :model="queryData" size="small" >
                    <el-form-item label="用户类型：">
                        <el-select v-model="queryData.user" clearable   placeholder="请选择">
                            <el-option v-for="item in users" :label="item.name" :key="item.id" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="日期：">
                        <el-date-picker
                                v-model="queryData.timeDate"
                                type="daterange"
                                :clearable="false"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd">
                        </el-date-picker>&emsp;&emsp;
                    </el-form-item>
                    <el-form-item label="渠道：">
                            <el-select v-model="queryData.channelId" @change="selectGoodsByChannelId($event)" clearable
                                    placeholder="请选择">
                                <el-option value="0" label="全部"></el-option>
                                <el-option value="-1" label="渠道汇总"></el-option>
                                <el-option v-for="item in channelList" :label="item.name" :key="item.id" :value="item.id"></el-option>
                            </el-select>
                            <el-select v-model="queryData.subChannelId" clearable @clear="clearValue" placeholder="请选择">
                                <el-option value="0" label="全部"></el-option>
                                <el-option value="-1" label="渠道汇总"></el-option>
                                <el-option v-for="item in subChannelList" :label="item.name" :key="item.id"
                                        :value="item.subChannel"></el-option>
                            </el-select>
                    </el-form-item>
                <el-form-item label="">
                    <el-button class="sub-sub9" type="primary" @click="query">查询</el-button>
                    <el-button class="sub-sub9" type="primary"  @click="exportExcel">导出</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <h1>
            <el-table
                    border
                    :data="chatReportList"
                    :header-cell-style="{background:'#282828'}"
                    ref="filterTable"
                    max-height="820">
                <el-table-column   label="日期" prop="dt" align="center"></el-table-column>
                <el-table-column   label="用户类型" prop="userType" align="center" :formatter="userTypeFormatter"></el-table-column>
                <el-table-column   label="渠道号" prop="channelId" align="center" :formatter="channelFormatter"></el-table-column>
                <el-table-column   label="子渠道号" prop="subChannelId" align="center"></el-table-column>
                <el-table-column   label="总领取人数" prop="totalUserCount" align="center"></el-table-column>
                <el-table-column   label="总领取数量" prop="totalNumberCount" align="center"></el-table-column>
                <el-table-column   label="新人福利领取人数" prop="newTaskUserCount" align="center"></el-table-column>
                <el-table-column   label="新人福利领取数量" prop="newTaskNumberCount" align="center"></el-table-column>
                <el-table-column   label="日常福利领取人数" prop="dayTaskUserCount" align="center"></el-table-column>
                <el-table-column   label="日常福利领取数量" prop="dayTaskNumberCount" align="center"></el-table-column>
                <el-table-column   label="累计签到领取人数" prop="signUserCount" align="center"></el-table-column>
                <el-table-column   label="累计签到领取数量" prop="signNumberCount" align="center"></el-table-column>
                <el-table-column   label="累计签到一次性任务领取人数" prop="signOnceUserCount" align="center"></el-table-column>
                <el-table-column   label="累计签到一次性任务领取数量" prop="signOnceNumberCount" align="center"></el-table-column>
            </el-table>
        </h1>
        <div>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="[20,50,100]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {
        downloadData,
        channelList,
        searchCoinReport
    } from "@/http/api";
    import utils from '@/utils'
    export default {
        name: "CoinReport",
        data(){
            return{
                // 这里新老用户的id和分享的对应不上因为计算方式不一样
                users: [{id: 0, name: '全部'},
                    {id: 1, name: '新用户'},
                    {id: 2, name: '老用户'}],
                channelList: [],
                subChannelList: [],                    
                queryData:{
                    user: null,
                    channelId: null,
                    subChannelId: null,
                    timeDate: ['', ''],
                },
                page: {
                    size: 20,
                    page: 1,
                    totalElements: null
                },
                versionList:[],
                chatRoomList:[],
                chatReportList:[]
            }
        },
        methods:{
            userTypeFormatter: function (row, column, cellValue){
                var temp="其他"
                this.users.forEach( item => {
                    if(item.id==cellValue){
                        temp=item.name;
                        } 
                })
                return temp
                }, 
            channelFormatter: function (row, column, cellValue){
                var temp="其他"
                this.channelList.forEach( item => {
                    if(item.id==cellValue){
                        temp=item.name;
                        } 
                })
                if(cellValue==='-1'){
                    temp=cellValue
                }
                return temp
                },
            selectGoodsByChannelId(val) {
                // this.watchTag = val;
                if (val !== null && val !== '' && val !== undefined && val !== '0' && val !== '-1') {
                    this.subChannelList = this.channelList.filter(channel => channel.id === val)[0].children.filter(subChannel => subChannel.state === 1);
                }
                if (val === '0' || val === '-1') {
                    this.subChannelList = [];
                }
                this.queryData.subChannelId=null;
            },
            clearValue(){
                this.queryData.subChannelId=null;
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.query();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.query();
            },
            exportExcel() {
                let fileName = new Date().toLocaleString() + '红包币日报.xlsx';
                downloadData(
                    '/coin/exportReportExcel',
                    Object.assign(this.queryData),
                    fileName
                )
            },
            query(){
                this.queryData.page = this.page.page;
                this.queryData.size = this.page.size;
                if (this.queryData.timeDate === null) {
                    this.queryData.timeDate = ['',''];
                }
                this.queryData.startTime = this.queryData.timeDate[0] ===''?null:this.queryData.timeDate[0];
                this.queryData.endTime = this.queryData.timeDate[1]===''?null:this.queryData.timeDate[1];
                searchCoinReport(this.queryData).then(resp=>{
                    this.chatReportList=resp.data.info.content;
                    this.page.totalElements =resp.data.info.totalElements;
                });
            }
        },
        // watch: {
        //     watchTag() {
        //         this.queryData.subChannelId = null;
        //     },
        //     },
        created() {
            this.queryData.timeDate=[utils.TodayUtil.getToday(),utils.TodayUtil.getToday()];
            channelList().then(resp => {
            this.channelList = resp.data.info;
            });
            this.query();
        }
    }
</script>

<style scoped>
    .sub-sub9{ position: relative; left: 110px}
</style>
